const data: { [name: string]: any } = {};

export function set(key: string, value: any) {
  return new Promise(resolve => {
    data[key] = value;
    resolve(data);
  });
}

export function get(key: string) {
  return data[key];
}
